import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import DistributorCreateViewModel from "viewModels/timeCharges/distributors/distributorManagement/distributorCreateViewModel";
import CreateView from "views/common/create";
import DistributorForm from "./distributorForm";

const DistributorCreateView: ViewComponent<DistributorCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<DistributorForm vm={vm} />} />
));

registerView(DistributorCreateView, DistributorCreateViewModel);
